import { render, staticRenderFns } from "./authorityContainer.vue?vue&type=template&id=095e9bab&scoped=true&"
import script from "./authorityContainer.vue?vue&type=script&lang=js&"
export * from "./authorityContainer.vue?vue&type=script&lang=js&"
import style0 from "./authorityContainer.vue?vue&type=style&index=0&id=095e9bab&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "095e9bab",
  null
  
)

export default component.exports